import { motion, AnimatePresence } from 'framer-motion';
import styled from 'styled-components';
import { ToastProps } from '@/types';
import { useEffect } from 'react';

const Overlay = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  cursor: pointer;
`;

const ToastWrapper = styled(motion.div)`
  position: fixed;
  top: 50%;
  left: 50%;
  background: white;
  padding: 40px 50px;
  border-radius: 25px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  z-index: 10001;
  max-width: 600px;
  text-align: center;
  cursor: pointer;
`;

const ToastTitle = styled.h2`
  color: #6B8E23;
  font-size: 36px;
  margin-bottom: 15px;
  font-weight: bold;
`;

const ToastDescription = styled.p`
  color: #333;
  font-size: 18px;
  line-height: 1.6;
`;

const DismissHint = styled.div`
  margin-top: 20px;
  color: #aaa;
  font-size: 12px;
  font-style: italic;
`;

const Category = styled.span`
  display: inline-block;
  background: #6B8E23;
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
  margin-bottom: 15px;
`;

export const Toast = ({ concept, isVisible, onClose }: ToastProps) => {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [isVisible, onClose]);

  return (
    <AnimatePresence>
      {isVisible && concept && (
        <>
          <Overlay
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />
          <ToastWrapper
            initial={{ scale: 0, opacity: 0, x: '-50%', y: '-50%' }}
            animate={{ scale: 1, opacity: 1, x: '-50%', y: '-50%' }}
            exit={{ scale: 0.8, opacity: 0, x: '-50%', y: '-50%' }}
            transition={{ type: "spring", damping: 15 }}
            onClick={onClose}
          >
            {concept.category && <Category>{concept.category}</Category>}
            <ToastTitle>{concept.full || concept.name}</ToastTitle>
            <ToastDescription>{concept.desc}</ToastDescription>
            <DismissHint>[clique para fechar]</DismissHint>
          </ToastWrapper>
        </>
      )}
    </AnimatePresence>
  );
};
